import React, { useEffect, useState, useContext, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import ReactTable from 'Components/ReactTable/ReactTable';
import { Container, Grid, Paper, MenuItem } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import CircularProgress from '@material-ui/core/CircularProgress';
import AsyncAutoComplete from 'Components/Inputes/AsyncAutoComplete';
import { SelectDownlinForDropDown as USER_SELECT_DOWNLINE } from 'Components/Api/UsersApi';
import { SelectByWalletIDAndReceiverID as WALLET_INFO } from 'Components/Api/WalletApi';

import {
    Add as CASH_COLLECT,
    SelectByUserID as SELECT_BY_USERID
} from 'Components/Api/CashCollectionAPI';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';

import {
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import { BalanceContext } from 'Components/BalanceContext';
import { MaterialCurrency } from 'Components/Inputes/MaterialCurrencyField';
import { NumberToWord } from 'Components/WordConverter/CustomConverter';
import { MaterialDatePickerField } from 'Components/Inputes/MaterialDatePickerField';
import InputLabel from 'Components/Inputes/InputLabel';
import { Select as SELECT_PAYMENT_MODE } from 'Components/Api/PaymentModesAPI';
import HOCLoader from 'Components/Loader/HOCLoader';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
const CustomContainer = HOCLoader(Container);

export const CashCollect = () => {
    const formRef = useRef();
    const { DashboardBalanceUpdate } = useContext(BalanceContext);
    const classes = commonStyle();
    const [responseMessage, setResponseMessage] = useState('');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [UserInfo, setUserInfo] = useState('');
    const [downline, setDownline] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);
    const [cashCollectionList, setCashCollectionList] = useState([]);

    const [TakeCount, setTakeCount] = useState(10);
    const [SkipCount, setSkipCount] = useState(0);
    const [downlineUserID, setDownlineUserID] = useState(0);
    const [paymentModes, setpaymentModes] = useState([]);
    const [isPin] = useState(localStorage.getItem('IsPin'));
    const [BackDateFundTransfer] = useState(
        localStorage.getItem('BackDateFundTransfer')
    );
    const [userDefault, setUserDefault] = useState({
        UserID: 0,
        FirmName: 'Select Receiver'
    });

    const [formObj, setFormObj] = useState({
        ReceiverID: userDefault,
        Amount: '',
        AmountInWords: '',
        UTRNumber: '',
        Remark: '',
        PayMode: '',
        Pin: '',
        IsPin: isPin,
        ToDate: new Date()
    });

    const validationSchema = Yup.object({
        User: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'User')
            .required(PLEASE_SELECT_VALID + 'User')
            .shape({
                UserID: Yup.string()
                    .notOneOf(['0'], PLEASE_SELECT_VALID + 'User')
                    .required(PLEASE_SELECT_VALID + 'User')
            }),

        Amount: Yup.number()
            .moreThan(0, PLEASE_PROVIDE_VALID + 'amount')
            .required(PLEASE_PROVIDE_VALID + 'amount'),

        Pin: Yup.number().when(['IsPin'], {
            is: (isPin) => isPin === 'true',
            then: Yup.number().required('Please enter pin')
        }),

        //UTRNumber: Yup.string().required(PLEASE_PROVIDE_VALID + 'UTR Number'),

        Remark: Yup.string().required(PLEASE_PROVIDE_VALID + 'remark'),

        PayMode: Yup.string().required(PLEASE_PROVIDE_VALID + 'paymode')
    });

    const selectPaymentModes = async () => {
        const response = await SELECT_PAYMENT_MODE();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);
        setpaymentModes(data);
    };

    const PayModeList = paymentModes.map(({ PaymentModeMasterID, Type }) => (
        <MenuItem key={PaymentModeMasterID} value={Type}>
            {Type}
        </MenuItem>
    ));

    const callSearch = async (text) => {
        if (
            text === undefined ||
            text === null ||
            text === '' ||
            text.length <= 0 ||
            text === userDefault.FirmName
        )
            return;

        var jsonObj = {
            FirmName: text
        };
        selectDownline(jsonObj);
    };

    const selectDownline = async (values) => {
        setLoadingOpen(true);
        var request = JSON.stringify(values);
        setLoadingOpen(false);
        const response = await USER_SELECT_DOWNLINE(request);

        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);

        setDownline(data);
    };

    const SelectCashCollectionReportByUserID = async (UserID) => {
        setDownlineUserID(UserID);
        var request = {
            TakeCount: TakeCount,
            SkipCount: SkipCount,
            UserID: UserID
        };

        setLoadingOpen(true);
        var json = JSON.stringify(request);
        const response = await SELECT_BY_USERID(json);

        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);

            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);
        createColumns();

        setCashCollectionList(data.data);
        //setTotalCount(data.Count);
    };

    const selectDownlineBalanceInformation = async (
        ReceiverID,
        setFieldValue
    ) => {
        if (ReceiverID <= 0) return;

        var request = {
            WalletID: 1,
            ReceiverID: ReceiverID
        };

        setLoadingOpen(true);
        var json = JSON.stringify(request);

        const response = await WALLET_INFO(json);

        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);

            setIsError(true);
            return;
        }

        const { Outstanding, BalanceDetail } = JSON.parse(response.data);
        setUserInfo(BalanceDetail);
        setFieldValue('Info', 'OS:' + Outstanding);
    };
    useEffect(() => {
        selectPaymentModes();
    }, []);

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'SRNO',
            srno: true
        });
        columns.push({
            label: 'Date',
            name: 'Date'
        });
        columns.push({
            label: 'FirmName',
            name: 'FirmName'
        });
        var textwrapwidth = 80;
        columns.push({
            label: 'Receive',
            name: 'AssignedUserName'
        });
        columns.push({
            label: 'Opening Os',
            name: 'OpeningBalance',
            textwrapwidth,
            numeric: true
        });
        columns.push({
            label: 'CollectionAmount',
            name: 'Amount',
            textwrapwidth,
            numeric: true
        });
        columns.push({
            label: 'Closing Os',
            name: 'ClosingBalance',
            textwrapwidth,
            numeric: true
        });

        columns.push({
            label: 'PayMode',
            name: 'PayMode'
        });
        columns.push({
            label: 'Remark',
            name: 'Remark'
        });

        setMainColumns(columns);
    };
    const updateReceiverID = async (value, setFieldValue) => {
        setFieldValue('ReceiverID', value.UserID);
        setUserDefault({
            UserID: value.UserID,
            FirmName: value.FirmName
        });
        await SelectCashCollectionReportByUserID(value.UserID);
        await selectDownlineBalanceInformation(value.UserID, setFieldValue);
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setLoadingOpen(true);
        var response = await CASH_COLLECT(JSON.stringify(values));
        if (!response.isAuthorized) LOGOUT();

        DashboardBalanceUpdate();
        setLoadingOpen(false);
        setSubmitting(false);

        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }
        setIsError(true);
        setResponseMessage(response.data);
        setSeverity('success');

        if (downlineUserID !== 0) {
            await SelectCashCollectionReportByUserID(downlineUserID);
        }
        resetForm(formObj);
        reset();
        setUserInfo('');
    };

    const OnCashCollectionAmountChange = (value, setFieldValue) => {
        if (value === undefined || value <= 0) {
            setFieldValue('AmountInWords');
            return;
        }
        setFieldValue('AmountInWords', NumberToWord(value));
    };
    const reset = () => {
        setUserInfo('');
        setUserDefault({
            UserID: 0,
            FirmName: 'Select User'
        });
        setFormObj({
            ReceiverID: userDefault,
            Amount: '',
            AmountInWords: '',
            Remark: '',
            PayMode: '',
            UTRNumber: '',
            ToDate: new Date()
        });
    };
    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                key={'formTransfer'}
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={submithandle}
                resetForm={formObj}
                render={({
                    values,
                    setFieldValue,
                    resetForm,
                    handleChange
                }) => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>
                                Cash Collection
                            </h2>
                            <Paper className={classes.PaperStyle}>
                                <Grid container item spacing={2}>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <Field
                                            component={AsyncAutoComplete}
                                            defaultValue={userDefault}
                                            FieldName="User"
                                            name="User"
                                            SubFieldName="UserID"
                                            options={downline}
                                            getOptionLabel={(option) =>
                                                option.FirmName
                                            }
                                            textFieldProps={{
                                                label: 'Select Receiver'
                                            }}
                                            onSearchCallback={(text) => {
                                                callSearch(text);
                                            }}
                                            onCustomCallback={(name, value) => {
                                                updateReceiverID(
                                                    value,
                                                    setFieldValue
                                                );
                                            }}
                                        />
                                        <InputLabel
                                            color="green"
                                            value={UserInfo}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <MaterialCurrency
                                            name="Amount"
                                            label="Collection Amount"
                                            placeholder="Amount"
                                            autoComplete="new-password"
                                            max={999999}
                                            onCustomCallback={(value) => {
                                                OnCashCollectionAmountChange(
                                                    value,
                                                    setFieldValue
                                                );
                                            }}
                                        />
                                        <InputLabel
                                            color="green"
                                            value={values.AmountInWords}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <MaterialSelect
                                            label="Pay Mode"
                                            name="PayMode"
                                            title="Select Mode"
                                        >
                                            <MenuItem key="0" value="0">
                                                Select Mode
                                            </MenuItem>
                                            {PayModeList}
                                        </MaterialSelect>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <MaterialTextField
                                            label="UTRNumber"
                                            name="UTRNumber"
                                            type="text"
                                            length={100}
                                            title="UTRNumber"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <MaterialTextField
                                            label="Collection Remark"
                                            name="Remark"
                                            type="text"
                                            length={100}
                                            title="Collection Remark"
                                        />
                                    </Grid>
                                    {isPin === 'true' ? (
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialNumberField
                                                label="Pin"
                                                type="password"
                                                name="Pin"
                                                placeholder="Pin"
                                                title="Pin"
                                                length={4}
                                            />
                                        </Grid>
                                    ) : null}
                                    {BackDateFundTransfer === 'true' ? (
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialDatePickerField
                                                name="ToDate"
                                                label="To Date"
                                                maxDate={new Date()}
                                            />
                                        </Grid>
                                    ) : null}
                                    <Grid item xs={12} sm={12} md={1} lg={1}>
                                        <PrimaryButton
                                            type="submit"
                                            title="Submit"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            disabled={loadingOpen}
                                        >
                                            Submit
                                        </PrimaryButton>
                                        {loadingOpen && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={1} lg={1}>
                                        <SecondaryButton
                                            type="reset"
                                            title="Reset"
                                            onClick={() => {
                                                reset();
                                            }}
                                            className={
                                                classes.CustomDangerButtonStyle
                                            }
                                        >
                                            Reset
                                        </SecondaryButton>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Form>
                    );
                }}
            />
            {BackDateFundTransfer === 'false' ? (
                <>
                    <h2 className={classes.PaperHead_h2}>Report</h2>
                    <ReactTable
                        data={cashCollectionList}
                        rowsPerPage={100}
                        columns={mainColumns}
                    />
                </>
            ) : null}
        </CustomContainer>
    );
};
